module.exports = __webpack_public_path__ + "img/3.5478f5c3.png";